// Auto-generated from BreakoutMarket.sol/BreakoutMarket.json
// Do not edit manually - run 'bun run generate:abi' to regenerate

export const breakoutMarketAbi = [
	{
		type: "constructor",
		inputs: [
			{
				name: "registry_",
				type: "address",
				internalType: "address",
			},
			{
				name: "permit2_",
				type: "address",
				internalType: "address",
			},
		],
		stateMutability: "nonpayable",
	},
	{
		type: "function",
		name: "DOMAIN_SEPARATOR",
		inputs: [],
		outputs: [
			{
				name: "",
				type: "bytes32",
				internalType: "bytes32",
			},
		],
		stateMutability: "view",
	},
	{
		type: "function",
		name: "PERMIT2",
		inputs: [],
		outputs: [
			{
				name: "",
				type: "address",
				internalType: "contract ISignatureTransfer",
			},
		],
		stateMutability: "view",
	},
	{
		type: "function",
		name: "REGISTRY",
		inputs: [],
		outputs: [
			{
				name: "",
				type: "address",
				internalType: "contract IBreakoutRegistry",
			},
		],
		stateMutability: "view",
	},
	{
		type: "function",
		name: "accruedProtocolFees",
		inputs: [],
		outputs: [
			{
				name: "",
				type: "uint256",
				internalType: "uint256",
			},
		],
		stateMutability: "view",
	},
	{
		type: "function",
		name: "addLiquidity",
		inputs: [
			{
				name: "amount",
				type: "uint256",
				internalType: "uint256",
			},
		],
		outputs: [],
		stateMutability: "nonpayable",
	},
	{
		type: "function",
		name: "bucketCount",
		inputs: [],
		outputs: [
			{
				name: "",
				type: "uint8",
				internalType: "uint8",
			},
		],
		stateMutability: "view",
	},
	{
		type: "function",
		name: "buy",
		inputs: [
			{
				name: "bucket",
				type: "uint8",
				internalType: "uint8",
			},
			{
				name: "shares",
				type: "uint256",
				internalType: "uint256",
			},
			{
				name: "maxCost",
				type: "uint256",
				internalType: "uint256",
			},
			{
				name: "deadline",
				type: "uint256",
				internalType: "uint256",
			},
		],
		outputs: [],
		stateMutability: "nonpayable",
	},
	{
		type: "function",
		name: "buyExactIn",
		inputs: [
			{
				name: "bucket",
				type: "uint8",
				internalType: "uint8",
			},
			{
				name: "usdcAmount",
				type: "uint256",
				internalType: "uint256",
			},
			{
				name: "minShares",
				type: "uint256",
				internalType: "uint256",
			},
			{
				name: "deadline",
				type: "uint256",
				internalType: "uint256",
			},
		],
		outputs: [],
		stateMutability: "nonpayable",
	},
	{
		type: "function",
		name: "buyWithPermit2",
		inputs: [
			{
				name: "permit",
				type: "tuple",
				internalType: "struct ISignatureTransfer.PermitTransferFrom",
				components: [
					{
						name: "permitted",
						type: "tuple",
						internalType: "struct ISignatureTransfer.TokenPermissions",
						components: [
							{
								name: "token",
								type: "address",
								internalType: "address",
							},
							{
								name: "amount",
								type: "uint256",
								internalType: "uint256",
							},
						],
					},
					{
						name: "nonce",
						type: "uint256",
						internalType: "uint256",
					},
					{
						name: "deadline",
						type: "uint256",
						internalType: "uint256",
					},
				],
			},
			{
				name: "transferDetails",
				type: "tuple",
				internalType: "struct ISignatureTransfer.SignatureTransferDetails",
				components: [
					{
						name: "to",
						type: "address",
						internalType: "address",
					},
					{
						name: "requestedAmount",
						type: "uint256",
						internalType: "uint256",
					},
				],
			},
			{
				name: "trader",
				type: "address",
				internalType: "address",
			},
			{
				name: "bucket",
				type: "uint8",
				internalType: "uint8",
			},
			{
				name: "usdcAmount",
				type: "uint256",
				internalType: "uint256",
			},
			{
				name: "minShares",
				type: "uint256",
				internalType: "uint256",
			},
			{
				name: "deadline",
				type: "uint256",
				internalType: "uint256",
			},
			{
				name: "signature",
				type: "bytes",
				internalType: "bytes",
			},
		],
		outputs: [],
		stateMutability: "nonpayable",
	},
	{
		type: "function",
		name: "calculateRequiredReserve",
		inputs: [
			{
				name: "b",
				type: "uint256",
				internalType: "uint256",
			},
			{
				name: "initialQuantities",
				type: "int256[]",
				internalType: "int256[]",
			},
		],
		outputs: [
			{
				name: "minReserve",
				type: "uint256",
				internalType: "uint256",
			},
		],
		stateMutability: "pure",
	},
	{
		type: "function",
		name: "claim",
		inputs: [],
		outputs: [],
		stateMutability: "nonpayable",
	},
	{
		type: "function",
		name: "claimWithSignature",
		inputs: [
			{
				name: "trader",
				type: "address",
				internalType: "address",
			},
			{
				name: "nonce",
				type: "uint256",
				internalType: "uint256",
			},
			{
				name: "deadline",
				type: "uint256",
				internalType: "uint256",
			},
			{
				name: "signature",
				type: "bytes",
				internalType: "bytes",
			},
		],
		outputs: [],
		stateMutability: "nonpayable",
	},
	{
		type: "function",
		name: "cutoffTime",
		inputs: [],
		outputs: [
			{
				name: "",
				type: "uint256",
				internalType: "uint256",
			},
		],
		stateMutability: "view",
	},
	{
		type: "function",
		name: "emergencyPause",
		inputs: [],
		outputs: [],
		stateMutability: "nonpayable",
	},
	{
		type: "function",
		name: "emergencyPausedAt",
		inputs: [],
		outputs: [
			{
				name: "",
				type: "uint256",
				internalType: "uint256",
			},
		],
		stateMutability: "view",
	},
	{
		type: "function",
		name: "emergencySweep",
		inputs: [
			{
				name: "to",
				type: "address",
				internalType: "address",
			},
		],
		outputs: [],
		stateMutability: "nonpayable",
	},
	{
		type: "function",
		name: "emergencyUnpause",
		inputs: [],
		outputs: [],
		stateMutability: "nonpayable",
	},
	{
		type: "function",
		name: "feeBps",
		inputs: [],
		outputs: [
			{
				name: "",
				type: "uint256",
				internalType: "uint256",
			},
		],
		stateMutability: "view",
	},
	{
		type: "function",
		name: "finalize",
		inputs: [
			{
				name: "nonce",
				type: "uint32",
				internalType: "uint32",
			},
		],
		outputs: [],
		stateMutability: "nonpayable",
	},
	{
		type: "function",
		name: "getAllQuantities",
		inputs: [],
		outputs: [
			{
				name: "quantities_",
				type: "int256[]",
				internalType: "int256[]",
			},
		],
		stateMutability: "view",
	},
	{
		type: "function",
		name: "getMarketInfo",
		inputs: [],
		outputs: [
			{
				name: "bucketCount_",
				type: "uint8",
				internalType: "uint8",
			},
			{
				name: "liquidityParam_",
				type: "uint256",
				internalType: "uint256",
			},
			{
				name: "feeBps_",
				type: "uint256",
				internalType: "uint256",
			},
			{
				name: "openTime_",
				type: "uint256",
				internalType: "uint256",
			},
			{
				name: "cutoffTime_",
				type: "uint256",
				internalType: "uint256",
			},
			{
				name: "status_",
				type: "uint8",
				internalType: "uint8",
			},
		],
		stateMutability: "view",
	},
	{
		type: "function",
		name: "getPrices",
		inputs: [],
		outputs: [
			{
				name: "",
				type: "uint256[]",
				internalType: "uint256[]",
			},
		],
		stateMutability: "view",
	},
	{
		type: "function",
		name: "getStatus",
		inputs: [],
		outputs: [
			{
				name: "",
				type: "uint8",
				internalType: "uint8",
			},
		],
		stateMutability: "view",
	},
	{
		type: "function",
		name: "getUserPosition",
		inputs: [
			{
				name: "user",
				type: "address",
				internalType: "address",
			},
		],
		outputs: [
			{
				name: "shares",
				type: "uint256[]",
				internalType: "uint256[]",
			},
			{
				name: "claimable",
				type: "uint256",
				internalType: "uint256",
			},
			{
				name: "claimed",
				type: "bool",
				internalType: "bool",
			},
		],
		stateMutability: "view",
	},
	{
		type: "function",
		name: "hasClaimed",
		inputs: [
			{
				name: "user",
				type: "address",
				internalType: "address",
			},
		],
		outputs: [
			{
				name: "",
				type: "bool",
				internalType: "bool",
			},
		],
		stateMutability: "view",
	},
	{
		type: "function",
		name: "initialize",
		inputs: [
			{
				name: "usdc_",
				type: "address",
				internalType: "address",
			},
			{
				name: "feeBps_",
				type: "uint256",
				internalType: "uint256",
			},
			{
				name: "openTime_",
				type: "uint256",
				internalType: "uint256",
			},
			{
				name: "cutoffTime_",
				type: "uint256",
				internalType: "uint256",
			},
			{
				name: "bucketCount_",
				type: "uint8",
				internalType: "uint8",
			},
			{
				name: "liquidityParam_",
				type: "uint96",
				internalType: "uint96",
			},
			{
				name: "initialQuantities",
				type: "int256[]",
				internalType: "int256[]",
			},
		],
		outputs: [],
		stateMutability: "nonpayable",
	},
	{
		type: "function",
		name: "invalidateNonce",
		inputs: [
			{
				name: "nonce",
				type: "uint256",
				internalType: "uint256",
			},
		],
		outputs: [],
		stateMutability: "nonpayable",
	},
	{
		type: "function",
		name: "liquidityParam",
		inputs: [],
		outputs: [
			{
				name: "",
				type: "uint256",
				internalType: "uint256",
			},
		],
		stateMutability: "view",
	},
	{
		type: "function",
		name: "openTime",
		inputs: [],
		outputs: [
			{
				name: "",
				type: "uint256",
				internalType: "uint256",
			},
		],
		stateMutability: "view",
	},
	{
		type: "function",
		name: "quoteBuy",
		inputs: [
			{
				name: "bucket",
				type: "uint8",
				internalType: "uint8",
			},
			{
				name: "shares",
				type: "uint256",
				internalType: "uint256",
			},
		],
		outputs: [
			{
				name: "cost",
				type: "uint256",
				internalType: "uint256",
			},
			{
				name: "fee",
				type: "uint256",
				internalType: "uint256",
			},
			{
				name: "total",
				type: "uint256",
				internalType: "uint256",
			},
		],
		stateMutability: "view",
	},
	{
		type: "function",
		name: "quoteExactIn",
		inputs: [
			{
				name: "bucket",
				type: "uint8",
				internalType: "uint8",
			},
			{
				name: "usdcAmount",
				type: "uint256",
				internalType: "uint256",
			},
		],
		outputs: [
			{
				name: "shares",
				type: "uint256",
				internalType: "uint256",
			},
			{
				name: "cost",
				type: "uint256",
				internalType: "uint256",
			},
			{
				name: "fee",
				type: "uint256",
				internalType: "uint256",
			},
			{
				name: "total",
				type: "uint256",
				internalType: "uint256",
			},
		],
		stateMutability: "view",
	},
	{
		type: "function",
		name: "quoteSell",
		inputs: [
			{
				name: "bucket",
				type: "uint8",
				internalType: "uint8",
			},
			{
				name: "shares",
				type: "uint256",
				internalType: "uint256",
			},
		],
		outputs: [
			{
				name: "proceeds",
				type: "uint256",
				internalType: "uint256",
			},
			{
				name: "fee",
				type: "uint256",
				internalType: "uint256",
			},
			{
				name: "total",
				type: "uint256",
				internalType: "uint256",
			},
		],
		stateMutability: "view",
	},
	{
		type: "function",
		name: "resolution",
		inputs: [],
		outputs: [
			{
				name: "winningOutcome",
				type: "uint8",
				internalType: "uint8",
			},
			{
				name: "dataUri",
				type: "string",
				internalType: "string",
			},
			{
				name: "nonce",
				type: "uint32",
				internalType: "uint32",
			},
			{
				name: "isResolved",
				type: "bool",
				internalType: "bool",
			},
			{
				name: "isFinalized",
				type: "bool",
				internalType: "bool",
			},
		],
		stateMutability: "view",
	},
	{
		type: "function",
		name: "resolve",
		inputs: [
			{
				name: "winningOutcome",
				type: "uint8",
				internalType: "uint8",
			},
			{
				name: "dataUri",
				type: "string",
				internalType: "string",
			},
		],
		outputs: [],
		stateMutability: "nonpayable",
	},
	{
		type: "function",
		name: "sell",
		inputs: [
			{
				name: "bucket",
				type: "uint8",
				internalType: "uint8",
			},
			{
				name: "shares",
				type: "uint256",
				internalType: "uint256",
			},
			{
				name: "minProceeds",
				type: "uint256",
				internalType: "uint256",
			},
			{
				name: "deadline",
				type: "uint256",
				internalType: "uint256",
			},
		],
		outputs: [],
		stateMutability: "nonpayable",
	},
	{
		type: "function",
		name: "sellWithSignature",
		inputs: [
			{
				name: "trader",
				type: "address",
				internalType: "address",
			},
			{
				name: "bucket",
				type: "uint8",
				internalType: "uint8",
			},
			{
				name: "shares",
				type: "uint256",
				internalType: "uint256",
			},
			{
				name: "minProceeds",
				type: "uint256",
				internalType: "uint256",
			},
			{
				name: "nonce",
				type: "uint256",
				internalType: "uint256",
			},
			{
				name: "deadline",
				type: "uint256",
				internalType: "uint256",
			},
			{
				name: "signature",
				type: "bytes",
				internalType: "bytes",
			},
		],
		outputs: [],
		stateMutability: "nonpayable",
	},
	{
		type: "function",
		name: "sweepProtocolFees",
		inputs: [],
		outputs: [],
		stateMutability: "nonpayable",
	},
	{
		type: "function",
		name: "sweepReserve",
		inputs: [],
		outputs: [],
		stateMutability: "nonpayable",
	},
	{
		type: "function",
		name: "totalClaimedPayouts",
		inputs: [],
		outputs: [
			{
				name: "",
				type: "uint256",
				internalType: "uint256",
			},
		],
		stateMutability: "view",
	},
	{
		type: "function",
		name: "totalLiquidity",
		inputs: [],
		outputs: [
			{
				name: "",
				type: "uint256",
				internalType: "uint256",
			},
		],
		stateMutability: "view",
	},
	{
		type: "function",
		name: "usdc",
		inputs: [],
		outputs: [
			{
				name: "",
				type: "address",
				internalType: "address",
			},
		],
		stateMutability: "view",
	},
	{
		type: "function",
		name: "usedNonces",
		inputs: [
			{
				name: "",
				type: "address",
				internalType: "address",
			},
			{
				name: "",
				type: "uint256",
				internalType: "uint256",
			},
		],
		outputs: [
			{
				name: "",
				type: "bool",
				internalType: "bool",
			},
		],
		stateMutability: "view",
	},
	{
		type: "event",
		name: "Claimed",
		inputs: [
			{
				name: "user",
				type: "address",
				indexed: true,
				internalType: "address",
			},
			{
				name: "payoutUsdc",
				type: "uint256",
				indexed: false,
				internalType: "uint256",
			},
		],
		anonymous: false,
	},
	{
		type: "event",
		name: "EmergencyPaused",
		inputs: [
			{
				name: "resolver",
				type: "address",
				indexed: true,
				internalType: "address",
			},
			{
				name: "pausedAt",
				type: "uint256",
				indexed: false,
				internalType: "uint256",
			},
		],
		anonymous: false,
	},
	{
		type: "event",
		name: "EmergencySwept",
		inputs: [
			{
				name: "to",
				type: "address",
				indexed: true,
				internalType: "address",
			},
			{
				name: "amount",
				type: "uint256",
				indexed: false,
				internalType: "uint256",
			},
		],
		anonymous: false,
	},
	{
		type: "event",
		name: "EmergencyUnpaused",
		inputs: [
			{
				name: "resolver",
				type: "address",
				indexed: true,
				internalType: "address",
			},
			{
				name: "unpausedAt",
				type: "uint256",
				indexed: false,
				internalType: "uint256",
			},
		],
		anonymous: false,
	},
	{
		type: "event",
		name: "Finalized",
		inputs: [
			{
				name: "winningOutcome",
				type: "uint8",
				indexed: true,
				internalType: "uint8",
			},
			{
				name: "finalizedAt",
				type: "uint256",
				indexed: false,
				internalType: "uint256",
			},
		],
		anonymous: false,
	},
	{
		type: "event",
		name: "Initialized",
		inputs: [
			{
				name: "version",
				type: "uint64",
				indexed: false,
				internalType: "uint64",
			},
		],
		anonymous: false,
	},
	{
		type: "event",
		name: "LiquidityAdded",
		inputs: [
			{
				name: "provider",
				type: "address",
				indexed: true,
				internalType: "address",
			},
			{
				name: "amount",
				type: "uint256",
				indexed: false,
				internalType: "uint256",
			},
			{
				name: "newLiquidityParam",
				type: "uint256",
				indexed: false,
				internalType: "uint256",
			},
			{
				name: "totalLiquidity",
				type: "uint256",
				indexed: false,
				internalType: "uint256",
			},
		],
		anonymous: false,
	},
	{
		type: "event",
		name: "MarketInitialized",
		inputs: [
			{
				name: "usdc",
				type: "address",
				indexed: true,
				internalType: "address",
			},
			{
				name: "bucketCount",
				type: "uint8",
				indexed: false,
				internalType: "uint8",
			},
			{
				name: "feeBps",
				type: "uint16",
				indexed: false,
				internalType: "uint16",
			},
			{
				name: "openTime",
				type: "uint40",
				indexed: false,
				internalType: "uint40",
			},
			{
				name: "cutoffTime",
				type: "uint40",
				indexed: false,
				internalType: "uint40",
			},
			{
				name: "initialLiquidity",
				type: "uint96",
				indexed: false,
				internalType: "uint96",
			},
		],
		anonymous: false,
	},
	{
		type: "event",
		name: "NonceInvalidated",
		inputs: [
			{
				name: "trader",
				type: "address",
				indexed: true,
				internalType: "address",
			},
			{
				name: "nonce",
				type: "uint256",
				indexed: false,
				internalType: "uint256",
			},
		],
		anonymous: false,
	},
	{
		type: "event",
		name: "ProtocolFeesSwept",
		inputs: [
			{
				name: "to",
				type: "address",
				indexed: true,
				internalType: "address",
			},
			{
				name: "amount",
				type: "uint256",
				indexed: false,
				internalType: "uint256",
			},
		],
		anonymous: false,
	},
	{
		type: "event",
		name: "ReserveSwept",
		inputs: [
			{
				name: "to",
				type: "address",
				indexed: true,
				internalType: "address",
			},
			{
				name: "amountUsdc",
				type: "uint256",
				indexed: false,
				internalType: "uint256",
			},
		],
		anonymous: false,
	},
	{
		type: "event",
		name: "Resolved",
		inputs: [
			{
				name: "winningOutcome",
				type: "uint8",
				indexed: true,
				internalType: "uint8",
			},
			{
				name: "dataUri",
				type: "string",
				indexed: false,
				internalType: "string",
			},
			{
				name: "nonce",
				type: "uint32",
				indexed: false,
				internalType: "uint32",
			},
		],
		anonymous: false,
	},
	{
		type: "event",
		name: "Trade",
		inputs: [
			{
				name: "trader",
				type: "address",
				indexed: true,
				internalType: "address",
			},
			{
				name: "bucket",
				type: "uint8",
				indexed: true,
				internalType: "uint8",
			},
			{
				name: "shares",
				type: "uint256",
				indexed: false,
				internalType: "uint256",
			},
			{
				name: "usdcAmount",
				type: "uint256",
				indexed: false,
				internalType: "uint256",
			},
			{
				name: "fee",
				type: "uint256",
				indexed: false,
				internalType: "uint256",
			},
			{
				name: "isBuy",
				type: "bool",
				indexed: false,
				internalType: "bool",
			},
		],
		anonymous: false,
	},
	{
		type: "error",
		name: "AlreadyClaimed",
		inputs: [],
	},
	{
		type: "error",
		name: "DeadlineExpired",
		inputs: [
			{
				name: "currentTime",
				type: "uint256",
				internalType: "uint256",
			},
			{
				name: "deadline",
				type: "uint256",
				internalType: "uint256",
			},
		],
	},
	{
		type: "error",
		name: "InsufficientLiquidity",
		inputs: [],
	},
	{
		type: "error",
		name: "InsufficientReserve",
		inputs: [
			{
				name: "reserve",
				type: "uint256",
				internalType: "uint256",
			},
			{
				name: "required",
				type: "uint256",
				internalType: "uint256",
			},
		],
	},
	{
		type: "error",
		name: "InsufficientShares",
		inputs: [
			{
				name: "requested",
				type: "uint256",
				internalType: "uint256",
			},
			{
				name: "available",
				type: "uint256",
				internalType: "uint256",
			},
		],
	},
	{
		type: "error",
		name: "InsufficientTransferAmount",
		inputs: [
			{
				name: "transferred",
				type: "uint256",
				internalType: "uint256",
			},
			{
				name: "required",
				type: "uint256",
				internalType: "uint256",
			},
		],
	},
	{
		type: "error",
		name: "InvalidBucket",
		inputs: [
			{
				name: "bucket",
				type: "uint8",
				internalType: "uint8",
			},
			{
				name: "bucketCount",
				type: "uint8",
				internalType: "uint8",
			},
		],
	},
	{
		type: "error",
		name: "InvalidBucketCount",
		inputs: [
			{
				name: "bucketCount",
				type: "uint8",
				internalType: "uint8",
			},
		],
	},
	{
		type: "error",
		name: "InvalidBucketCount",
		inputs: [
			{
				name: "bucketCount",
				type: "uint8",
				internalType: "uint8",
			},
		],
	},
	{
		type: "error",
		name: "InvalidCostCalculation",
		inputs: [],
	},
	{
		type: "error",
		name: "InvalidFeeBps",
		inputs: [
			{
				name: "feeBps",
				type: "uint256",
				internalType: "uint256",
			},
		],
	},
	{
		type: "error",
		name: "InvalidInitialization",
		inputs: [],
	},
	{
		type: "error",
		name: "InvalidPermitToken",
		inputs: [],
	},
	{
		type: "error",
		name: "InvalidQuantitiesSum",
		inputs: [],
	},
	{
		type: "error",
		name: "InvalidSignature",
		inputs: [],
	},
	{
		type: "error",
		name: "InvalidTiming",
		inputs: [
			{
				name: "openTime",
				type: "uint256",
				internalType: "uint256",
			},
			{
				name: "cutoffTime",
				type: "uint256",
				internalType: "uint256",
			},
		],
	},
	{
		type: "error",
		name: "InvalidTransferRecipient",
		inputs: [],
	},
	{
		type: "error",
		name: "InvalidWinningOutcome",
		inputs: [
			{
				name: "outcome",
				type: "uint8",
				internalType: "uint8",
			},
			{
				name: "bucketCount",
				type: "uint8",
				internalType: "uint8",
			},
		],
	},
	{
		type: "error",
		name: "MarketAlreadyFinalized",
		inputs: [],
	},
	{
		type: "error",
		name: "MarketNotClosed",
		inputs: [
			{
				name: "currentTime",
				type: "uint256",
				internalType: "uint256",
			},
			{
				name: "cutoffTime",
				type: "uint256",
				internalType: "uint256",
			},
		],
	},
	{
		type: "error",
		name: "MarketNotFinalized",
		inputs: [],
	},
	{
		type: "error",
		name: "MarketNotOpen",
		inputs: [
			{
				name: "currentTime",
				type: "uint256",
				internalType: "uint256",
			},
			{
				name: "openTime",
				type: "uint256",
				internalType: "uint256",
			},
			{
				name: "cutoffTime",
				type: "uint256",
				internalType: "uint256",
			},
		],
	},
	{
		type: "error",
		name: "MarketNotPaused",
		inputs: [],
	},
	{
		type: "error",
		name: "MarketNotResolved",
		inputs: [],
	},
	{
		type: "error",
		name: "MarketPaused",
		inputs: [],
	},
	{
		type: "error",
		name: "NonceMismatch",
		inputs: [
			{
				name: "provided",
				type: "uint32",
				internalType: "uint32",
			},
			{
				name: "expected",
				type: "uint32",
				internalType: "uint32",
			},
		],
	},
	{
		type: "error",
		name: "NotInitializing",
		inputs: [],
	},
	{
		type: "error",
		name: "NothingToClaim",
		inputs: [],
	},
	{
		type: "error",
		name: "Reentrancy",
		inputs: [],
	},
	{
		type: "error",
		name: "SlippageExceeded",
		inputs: [
			{
				name: "actual",
				type: "uint256",
				internalType: "uint256",
			},
			{
				name: "limit",
				type: "uint256",
				internalType: "uint256",
			},
		],
	},
	{
		type: "error",
		name: "Unauthorized",
		inputs: [],
	},
	{
		type: "error",
		name: "ZeroAddress",
		inputs: [],
	},
	{
		type: "error",
		name: "ZeroAmount",
		inputs: [],
	},
	{
		type: "error",
		name: "ZeroShares",
		inputs: [],
	},
] as const
